export function translateMessageError (code: string) {

    const objMessages = {
        "2" : "Validade: formato preenchida é inválida.",
        "5" : "CVV: formato preenchido é inválido.",
        "16" : "Código de segurança inválido.",
        "33" : "O cartão está expirado.",
        "49" : "O valor da transação excede o autorizado.",
        "51" : "Saldo insuficiente.",
        "53" : "Transação não permitida para o emissor. Fale com a Rede.",
        "55" : "Código PIN inválido.",
        "58" : "Não autorizado. Transação ilegal.",
        "69" : "Transação não permitida para este produto ou serviço.",
        "78" : "Transação não existe.",
        "80" : "Não autorizado. Entre em contato com o emissor. (Fundos insuficientes)",
        "82" : "Unauthorized transaction for debit card.",
        "86" : "Cartão expirado.",
        "88" : "Comerciante não aprovado. Regularize seu site e entre em contato com a Rede para voltar a negociar.",
        "101" : "Não autorizado. Problemas no cartão, entre em contato com o emissor.",
        "102" : "Não autorizado. Verifique a situação da loja com o emissor.",
        "103" : "Não autorizado. Tente novamente.",
        "104" : "Não autorizado. Tente novamente.",
        "105" : "Não autorizado. Cartão restrito.",
        "106" : "Erro no processamento do emissor. Por favor, tente novamente.",
        "108" : "Não autorizado. Valor não permitido para este tipo de cartão.",
        "110" : "Não autorizado. Tipo de transação não permitido para este cartão.",
        "111" : "Não autorizado. Saldo insuficiente.",
        "112" : "Não autorizado. Tempo limite para pagamento expirou.",
        "113" : "Não autorizado. Risco moderado identificado pelo emissor.",
        "115" : "Não autorizado. Excedeu o limite de transações permitidas no período.",
        "116" : "Não autorizado. Entre em contato com o emissor do cartão.",
        "118" : "Não autorizado. Cartão bloqueado.",
        "119" : "Não autorizado. Código de segurança inválido",
        "123" : "Não autorizado. Portador solicitou o fim das recorrências no emissor.",
        "Invalid parameter(s). Your 'taxpayer_id' value is incorrect. Please verify request parameters." : "CPF digitado é inválido."
    }

    return objMessages[code as keyof typeof objMessages] ?? null
}